export default __webpack_public_path__ + "static/media/cpr1.d60437c7.jpg";